'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RatingDisplay", {
    enumerable: true,
    get: function() {
        return RatingDisplay;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useRatingDisplay = require("./useRatingDisplay");
const _renderRatingDisplay = require("./renderRatingDisplay");
const _useRatingDisplayStylesstyles = require("./useRatingDisplayStyles.styles");
const _useRatingDisplayContextValues = require("./useRatingDisplayContextValues");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const RatingDisplay = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useRatingDisplay.useRatingDisplay_unstable)(props, ref);
    const contextValues = (0, _useRatingDisplayContextValues.useRatingDisplayContextValues)(state);
    (0, _useRatingDisplayStylesstyles.useRatingDisplayStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useRatingDisplayStyles_unstable')(state);
    return (0, _renderRatingDisplay.renderRatingDisplay_unstable)(state, contextValues);
});
RatingDisplay.displayName = 'RatingDisplay';
